import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import CoverageMapPanel from "@/components/admin/CoverageMapPanel";

export default function FullscreenCoverageMap() {
  const navigate = useNavigate();
  return (
    <div className="h-screen flex flex-col" data-testid="fullscreen-coverage-map">
      <div className="flex items-center gap-3 px-4 py-2 bg-slate-900 text-white">
        <button onClick={() => navigate("/admin")} className="w-8 h-8 rounded-full bg-slate-800 flex items-center justify-center" data-testid="fullscreen-back-btn">
          <ArrowLeft className="w-4 h-4" />
        </button>
        <p className="text-sm font-bold">BirthdayDeaLight Coverage Map</p>
      </div>
      <div className="flex-1 overflow-hidden">
        <CoverageMapPanel fullscreen />
      </div>
    </div>
  );
}
